// extracted by mini-css-extract-plugin
module.exports = {"Heading":"AddColumnModal_Heading__3_OTR"};